import { render, staticRenderFns } from "./LocalizedAlert.vue?vue&type=template&id=2c3ef89b&scoped=true&"
import script from "./LocalizedAlert.vue?vue&type=script&lang=js&"
export * from "./LocalizedAlert.vue?vue&type=script&lang=js&"
import style0 from "./LocalizedAlert.vue?vue&type=style&index=0&id=2c3ef89b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ef89b",
  null
  
)

export default component.exports